import React from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import MachineSheetRectangle from 'components/layout_and_quote_builder/MachineSheetRectangle.jsx';
import machineSheetText from 'components/layout_and_quote_builder/utils/machineSheetText.js';

// One machine box inside a Manufacturing Line card: a role header (PRINTING / DIE CUTTING), the machine
// name and its type, and its bed drawn to scale (MachineSheetRectangle) with the height X width shorthand
// below it (vertical side first, matching the standard boards -- e.g. "560mm X 770mm"). Shared by
// ManufacturingLineCard (a single line) and the Manufacturing Line List card (its printing / die-cutting
// columns), so the boxes look identical in both.
// style is merged onto the box (e.g. flex: '0 0 auto' when the box is stacked in a column rather than sharing
// a row), so the same box works both side by side and stacked.
const MachineColumn = ({ label, machineName, machineTypeLabel, widthMm, heightMm, kind, maxMachineDimensionMm, style, partLabels = [] }) => {
  return (
    <div className={styles.layout_column} style={{
      display: 'flex', flexDirection: 'column',
      padding: '14px 10px', borderRadius: '10px', background: '#fff',
      border: '1px solid #ececec', boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
      ...(style || {})
    }}>
      {/* The part(s) this machine makes. A machine shared between parts (one die-cutter used by both Cover and
          Tray) shows every part it makes, which is why the badge rides on the machine box rather than heading
          the card. Keyed by position, not by the label -- two sub_sections of one section can share a label
          (LayoutNavBuilder flat_maps them), and React would then drop a badge. */}
      {partLabels.length > 0 && (
        <div className={styles.part_badges_container} style={{ justifyContent: 'center', marginBottom: '8px' }}>
          {partLabels.map((partLabel, position) => (
            // The badge sits in a narrow machine box, so a long label (a combined "Inner tray & Sleeve cover")
            // must WRAP within the column rather than overflow and clip -- override the pill's nowrap and cap it
            // at the box width. The pill grows to two lines instead of running off the card.
            <span
              key={`${position}:${partLabel}`}
              className={styles.efficiency_badge}
              style={{ whiteSpace: 'normal', maxWidth: '100%', textAlign: 'center', lineHeight: 1.25 }}
            >
              {partLabel}
            </span>
          ))}
        </div>
      )}
      <div className={styles.layout_column_label} style={{ color: '#222' }}>{label}</div>
      {/* Machine name is the hero of the box — the largest, darkest text. It reserves TWO lines (minHeight)
          even when it fits on one, so a one-line name ("Ryobi 525 GX") and a two-line one ("Heidelberg
          Cylinder SBG") take the same vertical space -- which lines the machine-type label up across cards and
          keeps the boxes the same height instead of each list card sizing to its own longest name. */}
      <div style={{ fontSize: '13px', fontWeight: 600, color: '#222', lineHeight: 1.3, marginTop: '2px', minHeight: '2.6em' }}>{machineName}</div>
      {/* The machine's type ("Digital cutting", "Offset", ...) so the user knows WHAT they are selecting —
          for example only digital cutters run the whole-sheet L-shape solutions. */}
      {machineTypeLabel ? (
        <div style={{ fontSize: '12px', fontWeight: 400, color: '#888', lineHeight: 1.3, marginTop: '2px' }}>{machineTypeLabel}</div>
      ) : null}

      <div style={{ marginTop: 'auto' }}>
        <MachineSheetRectangle widthMm={widthMm} heightMm={heightMm} kind={kind} maxMm={maxMachineDimensionMm} />
        {/* Redundant with the bed's own edge labels, so it's the quietest line — small and gray. */}
        {widthMm && heightMm ? (
          <div style={{ fontSize: '12px', fontWeight: 400, color: '#888', marginTop: '2px' }}>{machineSheetText(widthMm, heightMm)}</div>
        ) : null}
      </div>
    </div>
  );
};

export default MachineColumn;
